/**
 * Tipi UI consumati dai componenti Home.
 * Volutamente disaccoppiati dai tipi GraphQL (`src/lib/graphql/types.ts`):
 * gli `adapters.ts` fanno la traduzione AppSync → questi.
 */

import type { InvoiceStatus } from '@/components/ui/badge'
import { formatBackendDate } from '@/lib/dates'

export type Invoice = {
  id: string
  code: string
  periodLabel: string
  amount: number
  currency: 'EUR'
  status: InvoiceStatus
  dueDate: string
  consumptionKwh: number
  paymentMethod: 'Bonifico' | 'Bollettino' | 'SDD' | 'Prepagata' | 'Sardex'
}

export type MonthlyConsumption = {
  month: string
  current: number
  previous: number
}

export type NewsItem = {
  id: string
  title: string
  excerpt: string
  date: string
  tag?: string
  imageUrl?: string
}

export type AutoletturaMode = 'closed' | 'preview' | 'open'

export type AutoletturaWindow = {
  /** Modalità della finestra:
   *  - 'open'    → invio possibile
   *  - 'preview' → la finestra apre tra 1 giorno (heads-up, niente CTA azione)
   *  - 'closed'  → niente da mostrare
   */
  mode: AutoletturaMode
  /** Data di chiusura della prossima finestra (o di quella aperta). */
  closesOn?: string
  /** Data di apertura della prossima finestra (utile in mode 'preview'). */
  opensOn?: string
  /** Etichetta o indirizzo del POD (es. "Casa" o "Via Roma 12"). */
  podDisplay?: string
  /** Codice POD tecnico (es. "IT001E12345678"). */
  podCode?: string
}

// =====================================================================
// Formatter condivisi
// =====================================================================

export function formatEuro(value: number): string {
  return new Intl.NumberFormat('it-IT', {
    style: 'currency',
    currency: 'EUR',
  }).format(value)
}

/**
 * Formatta una data che può arrivare:
 *  - in formato backend italiano `DD/MM/YYYY` (es. "31/01/2026")
 *  - in formato ISO `YYYY-MM-DD` (es. "2026-01-31")
 *  - mancante / null
 */
export function formatDateShort(value: string | null | undefined): string {
  return formatBackendDate(value)
}
